import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./app/page";
import ThanksPage from "./app/ThanksPage";
import EmployeePage from "./app/employee/employee-page/EmployeePage";
import QrValidation from "./app/qr-validation/QRValidation";
import EmployeeFormPage from "./app/employee/employee-form/EmployeeFormPage";
import NFCPage from "./app/nfc/NFCPage";
import About from "./app/About";
import MeetUp from "./app/MeetUp";
import Profile from "./app/Profile";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thanks" element={<ThanksPage />} />
        <Route path="/about" element={<About />} />
        <Route path={"/employee"} element={<EmployeePage />} />
        <Route path="/validate/qr/:userId" element={<QrValidation />} />
        <Route path="/card/:id/" element={<EmployeeFormPage />} />
        <Route path={"/nfc"} element={<NFCPage />} />
        <Route path={"/pdmeetup2025"} element={<MeetUp />} />
        <Route path={"/FrancoJohnCarlo"} element={<Profile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
